import type { RuteroLuggageSelection, RuteroTransferLuggageQuote } from '@bandido/shared/types';
import type { OfferOptionsSelectionPreview } from './queries';
import type { SelectionPreviewDisplay } from './offerOptionsPreview';
import { emptyTransferLuggage, TransferLuggageDraft } from './transferLuggage';

export function initialTransferLuggage(
  quote: RuteroTransferLuggageQuote | undefined,
  requested?: RuteroLuggageSelection,
): TransferLuggageDraft {
  const luggage = quote?.status === 'quoted' ? quote.luggage : requested;
  return luggage
    ? { mode: 'specified', checked: String(luggage.checked), carryOn: String(luggage.carryOn) }
    : emptyTransferLuggage();
}

/** Only the current, complete quote can authorize luggage and its hold token. */
export function transferLuggageQuoteDisplay(
  display: SelectionPreviewDisplay,
  luggage: RuteroLuggageSelection | null | undefined,
  preview: OfferOptionsSelectionPreview | undefined,
  now: number,
): SelectionPreviewDisplay {
  const complete =
    display.authoritative &&
    !!luggage &&
    preview?.state === 'priced' &&
    !!preview.total &&
    !!preview.quoteToken &&
    preview.luggage?.checked === luggage.checked &&
    preview.luggage?.carryOn === luggage.carryOn &&
    (!preview.expiresAt || Date.parse(preview.expiresAt) > now);
  return complete
    ? display
    : {
      amountMinor: undefined,
      authoritative: false,
      notice: display.notice ?? 'unavailable',
      holdBlocked: true,
    };
}
